module.exports = __webpack_public_path__ + "img/logo-appart-fitness.b18691e2.jpg";